"use client";

import useAxiosPublicInstance from "@/hooks/useAxiosPublicInstance";
import { useEffect, useState } from "react";

export default function useGetVideo() {
  const [link, setLink] = useState("");
  const axiosPublicInstance = useAxiosPublicInstance();

  useEffect(() => {
    async function fetchVideo() {
      try {
        const { data } = await axiosPublicInstance.get(
          "websiteContents/youtubeLink"
        );
        setLink(data[0]?.link);
      } catch {
        setLink("");
      }
    }
    fetchVideo();
  }, []);
  return link;
}
